import React, { Component } from 'react';
import { connect } from 'react-redux';
import '../../../scss/components/pages/signTime.scss';
import axios from 'axios';
import Select from 'react-select'
import API from '../../../middleware/API';
import EditOvertime from '../../EditOvertime';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import swal from 'sweetalert2';
import Slider from 'react-slick';
import FillLeave from '../../FillLeave'

import Pagination from '../../Pagination';
import { buildOvertimeRange } from '../../util/overtimeTime';
import {
  getPersonalAttendance,
  InitAPIStatus
} from '../../../store/action';

// onChangeFunc={this.handleOnChangeFillLeaveInput}
class PersonalSignInOutTime extends Component {
  constructor(props) {
    super(props);
    let start = moment().add(0, 'month').format('YYYY-MM') + '-01';
    let end = moment(start).add(1, 'month').add(-1, 'days').format('YYYY-MM-DD');
    const strNoDate = 'N/A';
    this.state = {
      start: moment().add(0, 'month').format('YYYY-MM') + '-01',
      end: moment(start).add(1, 'month').add(-1, 'days').format('YYYY-MM-DD'),
      editTargetId:0,
      editFillLeaveId:0,
      editType: 'ADD',
      isEditShow: false,
      isFillLeaveOpen: false,
      
      currPage: 1,
      countOfPage: 10,
      remainHours: 0,
      compensatoryHours:0,
      signingCompensatoryHours:0,
      signingAnnualHours:0,
      searchStartDate: moment(start),
      searchEndDate: moment(end),
      isAddWorkTimeOpen: false,
      longLeave: false,
      leaveTypeList: [],
      employees:[],
      editOvertime: {
        id: -1,
        eventId:-1,
        startAt:moment(),
        endAt:moment(),
        reason:'',
        notes:'',
        hasRest: false,
      },
      editFillLeaveTarget:{
        sDate: moment().startOf('hour').format('YYYY-MM-DDTHH:mm'),
        eDate: moment().startOf('hour').format('YYYY-MM-DDTHH:mm'),
        leaveItemId: 0,
        agentUserId: 0,
        leaveHours: 0,
        reasons: '',
        notes: '',
        fileName: '',
    }
    }
    this.handleOnChangeInput = this.handleOnChangeInput.bind(this);
    this.toggleEditBlockShow = this.toggleEditBlockShow.bind(this);
    this.handleSaveStaff = this.handleSaveStaff.bind(this)
    this.handleSearchStartDateChange = this.handleSearchStartDateChange.bind(this);
    this.handleSearchEndDateChange = this.handleSearchEndDateChange.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleSearchButton = this.handleSearchButton.bind(this);
    this.cutTimeFunc = this.cutTimeFunc.bind(this);
    this.handleFillLeave = this.handleFillLeave.bind(this);

    this.handleToggleOpenAddWorkTimeBlock = this.handleToggleOpenAddWorkTimeBlock.bind(this);
    this.handleToggleOpenFillLeaveBlock = this.handleToggleOpenFillLeaveBlock.bind(this);
    this.onChangStep = this.onChangeStep.bind(this)
    this.diff = this.diff.bind(this)
    this.diffLeave = this.diffLeave.bind(this)
    this.wholeTime = this.wholeTime.bind(this)
    this.totalTime = this.totalTime.bind(this)
    this.overTimeStatusStr = this.overTimeStatusStr.bind(this)
    this.overTimeStatus = this.overTimeStatus.bind(this)
    this.styleTime = this.styleTime.bind(this)
    this.delay = this.delay.bind(this)
    this.handleOnChangeFillLeaveInput = this.handleOnChangeFillLeaveInput.bind(this);

    this.calculateTotalWorkTime = this.calculateTotalWorkTime.bind(this)
    this.handleOvertimeButton = this.handleOvertimeButton.bind(this)

    this.resetEditTarget = this.resetEditTarget.bind(this);

  }
  componentDidMount() {
    this.props.getPersonalAttendance({
      start: this.state.searchStartDate.format('YYYY-MM-DD'),
      end:  this.state.searchEndDate.format('YYYY-MM-DD'),
      page: this.state.currPage,
      pageSize: this.state.countOfPage,
    });

    API.get('Leave').then((res) => {
      if (res) {        
        this.setState({
          leaveTypeList: res,
        });
      }
    }); 
    API.get('User/All').then((res) => {
      if (res) {
        this.setState({
          employees: res
        })
      }
    });
    API.get('LeaveRec?status=').then((response) => {
      if (response) {
        this.setState({
          remainHours: response.remainHours,
          compensatoryHours: response.compensatoryHours,
          signingCompensatoryHours: response.signingCompensatoryHours,
          signingAnnualHours: response.signingAnnualHours,
          
        });
      }
    })
  }
  resetEditTarget(){
    let emptyTarget = {
        sDate: moment().startOf('hour').format('YYYY-MM-DDTHH:mm'),
        eDate: moment().startOf('hour').format('YYYY-MM-DDTHH:mm'),
        leaveItemId: 0,
        agentUserId: 0,
        leaveHours: 0,
        reasons: '',
        notes: '',
        fileName: '',
    }

    this.setState({
      editFillLeaveTarget:emptyTarget       
      });
  }
  handleOnChangeFillLeaveInput(key, e) {
    let newObj = Object.assign(this.state.editFillLeaveTarget);
    if(moment.isMoment(e)){
      newObj[key] = e;
    }else if(key === 'reasons'){
      newObj[key] = e.target.value;
    }else if(key === 'setDate'){        
      newObj['sDate'] = e + 'T' + newObj['sDate'].split('T')[1];
      newObj['eDate'] = e + 'T' + newObj['eDate'].split('T')[1];
    }else if(key === 'workingHours'){
      newObj[key] = parseFloat(e.target.value, 10);
    }else if(typeof e === 'string'){
      newObj[key] = e;
    }else{
      newObj[key] = parseInt(e.target.value, 10);
    }
    console.log(key)
    console.log(e)
    if(key === 'eDate' || key === 'sDate'){
      newObj['leaveHours'] = this.diffLeave(newObj['sDate'].split('T')[1] ,newObj['eDate'].split('T')[1] )
    }

    this.setState({
      editFillLeaveTarget: newObj
    });
  }
  handleToggleOpenAddWorkTimeBlock(targetDate, targetId, islongLeave) {    
    
    this.setState({
      editTargetDate: targetDate,
      editTargetId: targetId,
      isAddWorkTimeOpen: !this.state.isAddWorkTimeOpen,
      longLeave: islongLeave
    });
  }

  handleToggleOpenFillLeaveBlock(targetDate, targetId, requestType) {        
    if(this.state.isFillLeaveOpen){
        this.resetEditTarget();
    }
    console.log(targetId)
    if(targetId !== -1 && targetId){
        this.setState({
          editFillLeaveTarget: this.state.leaveRecList.find(leaveRec => leaveRec.id === targetId),
            editFillLeaveId: targetId,
            isFillLeaveOpen: !this.state.isFillLeaveOpen,
            requestType: requestType
          });
    }else{

        let emptyTarget = {
            sDate: moment().startOf('hour').format('YYYY-MM-DDTHH:mm'),
            eDate: moment().startOf('hour').format('YYYY-MM-DDTHH:mm'),
            leaveItemId: 0,
            agentUserId: 0,
            leaveHours:0,
            reasons: '',
            notes: '',
            fileName: '',
        }
        
        this.setState({
          editFillLeaveTarget: emptyTarget,
          editFillLeaveDate: targetDate,
            editFillLeaveId: targetId,
            isFillLeaveOpen: !this.state.isFillLeaveOpen,
            requestType: requestType
          });
    }

  }
  calculateTotalWorkTime (totalWorkTime){
    var hourMinuteArr = totalWorkTime.split('.');
    // var newMinute = 0;
    // if(hourMinuteArr[1] < 10 && hourMinuteArr[1] >= 5)
    //   newMinute = 5;
    // else if(hourMinuteArr[1] < 5 && hourMinuteArr[1] >= 0)
    //   newMinute = 0;

    //return totalWorkTime;
    return `${hourMinuteArr[0]}.${hourMinuteArr[1]}`;
  }
  handleSearchStartDateChange(date) {
    this.setState({
      searchStartDate: date
    })
  }
  handleFillLeave(data) {

    let {id, leaveItemId, sDate, eDate, agentUserId, reasons, leaveHours} = this.state.editFillLeaveTarget;
    let {requestType} = this.state;
    let request = {
        id: id,
        leaveItemId: leaveItemId,
        sDate: sDate,
        eDate: eDate,
        agentUserId: agentUserId,
        reasons: reasons,
        leaveHours: leaveHours,
        status: 'S'
    }
    if(data){
      var formData = new FormData();
      formData.append("PicFile", data);
      axios.post('https://wisdombank.liangshishu.com/member/api/FileUploader/CafeLeavePic', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((res) => {
        console.log(res)
        if(res.data.indexOf('Error') !== -1)
        {
          swal({type:'error',title:'檔案上傳失敗，請重新再試'});
          return;
        }
        request.fileName = res.data.split('/')[res.data.split('/').length-1];

        if (requestType === 'ADD'){
            API.post('LeaveRec', request).then((response) => {
                if (response) {
                    this.resetEditTarget();
                    //this.loadRecList()
                }else{
                  swal({type:'error',title:'該時段已有其他假單'})
                }
              });
        }else{
            API.put('LeaveRec/'+request.id, request).then((response) => {
                if (response) {
                    this.resetEditTarget();
    this.props.getPersonalAttendance({
      start: this.state.searchStartDate.format('YYYY-MM-DD'),
      end:  this.state.searchEndDate.format('YYYY-MM-DD'),
      page: this.state.currPage,
      pageSize: this.state.countOfPage,
    });                }
              });
        }

      });
    }else{
        if (requestType === 'ADD'){
            API.post('LeaveRec', request).then((response) => {

                if (response) {
                    swal({type:'success',title:'新增成功'})

                    this.resetEditTarget();
    this.props.getPersonalAttendance({
      start: this.state.searchStartDate.format('YYYY-MM-DD'),
      end:  this.state.searchEndDate.format('YYYY-MM-DD'),
      page: this.state.currPage,
      pageSize: this.state.countOfPage,
    });
                  }else{
                  swal({type:'error',title:'該時段已有其他假單'})
                }
              });
        }else{
            API.put('LeaveRec/'+request.id, request).then((response) => {

                if (response) {
                    swal({type:'success',title:'編輯成功'})

                    this.resetEditTarget();
    this.props.getPersonalAttendance({
      start: this.state.searchStartDate.format('YYYY-MM-DD'),
      end:  this.state.searchEndDate.format('YYYY-MM-DD'),
      page: this.state.currPage,
      pageSize: this.state.countOfPage,
    });
                  }
              });
        }
    }
    
  }
  handleSearchEndDateChange(date) {
    this.setState({
      searchEndDate: date
    })
  }

  handleOvertimeButton(eventId, overTimeId) {
    console.log('handleOvertimeButton')
    let { count, records } = this.props.PersonsSignInTimeState;

    var eventObj = records.find(m=>m.id === eventId);

    let newObj = JSON.parse(JSON.stringify((this.state.editOvertime)));
    // 帶 overTimeId 進來才是編輯既有加班單，否則一律視為新增
    const isEdit = overTimeId !== -1 && eventObj.overTimeData.length > 0;

    if(isEdit){
      var editOverTimeData = eventObj.overTimeData.find(m=>m.id === overTimeId);
      newObj.id = overTimeId;
      newObj.eventId = eventId;
      newObj.startAt=moment(editOverTimeData.startAt);
      newObj.endAt=moment(editOverTimeData.endAt);
      newObj.reason=editOverTimeData.reason;
      newObj.date=eventObj.expectedDate;
      newObj.notes = editOverTimeData.notes
    }else{
      newObj.id = -1;
      newObj.eventId = eventId;
      newObj.startAt=moment(eventObj.expectedDate+'T'+eventObj.expectedSignInTime);
      newObj.endAt=moment(eventObj.expectedDate+'T'+eventObj.expectedSignOutTime);
      newObj.reason='';
      newObj.date=eventObj.expectedDate;
      newObj.hasRest = false;
    }


    this.setState({
      editOvertime: newObj,
      editType: isEdit ? 'EDIT' : 'ADD',
    }, () => {
      this.toggleEditBlockShow();
    })


  }
  
  handleEditOvertimeButton(overtimeId) {

  }
  toggleEditBlockShow() {
    console.log(this.state.isEditShow)
    if (this.state.isEditShow === true) {
      let newObj = JSON.parse(JSON.stringify((this.state.editOvertime)));
      newObj.id = -1;
      newObj.eventId = -1;
      newObj.startAt=moment();
      newObj.endAt=moment();
      newObj.reason='';
      newObj.date='';
      newObj.notes='';
      newObj.hasRest=false;
      this.setState({
        editOvertime: newObj,
        isEditShow: false
      });
    } else {
       this.setState({
        isEditShow: true
      })
    }
  }
  handleChangePage(page) {
    this.setState({currPage: page})
  }
  wholeTime (a, b, c) {
    let parta = [];
    let partb = [];
    let partc = [];
    let hourTotal = 0;
    let minTotal = 0;
    if(a){
      parta = a.split(":");
    }
    if(b){
      partb = b.split(":");
    }
    if(c){
      partc = c.split(":");
    }
    
    if(parta.length > 1 && partb.length > 1)
    {
      minTotal = parseInt(parta[1]) + parseInt(partb[1]);
      if (minTotal >= 60){
        hourTotal =  parseInt(minTotal / 60) ;
        minTotal = minTotal % 60;
      }
      hourTotal = hourTotal + parseInt(parta[0]) + parseInt(partb[0]);
      if(partc.length > 1){
        minTotal = minTotal + parseInt(partc[1]);

        if (minTotal >= 60){
          hourTotal = hourTotal + parseInt(minTotal / 60) ;
          minTotal = minTotal % 60;
        }
        hourTotal = hourTotal + parseInt(partc[0]);

      }
    }

    // If using time pickers with 24 hours format, add the below line get exact hours
    // if (hours < 0)
    //    hours = hours + 24;

    return (hourTotal <= 9 ? "0" : "") + hourTotal + ":" + (minTotal <= 9 ? "0" : "") + minTotal;
  }
  delay(expected, actual){
    expected = expected.split(":");
    actual = actual.split(":");
    var expectedDate = new Date(0, 0, 0, expected[0], expected[1], 0);
    var actualDate = new Date(0, 0, 0, actual[0], actual[1], 0);
    if (actualDate <= expectedDate){
      return "0"
    }
    var diff = actualDate.getTime() - expectedDate.getTime();
    var hours = Math.floor(diff / 1000 / 60 / 60);
    diff -= hours * 1000 * 60 * 60;
    var minutes = Math.floor(diff / 1000 / 60);
    if (hours < 0)
    hours = hours + 24;
    return {hours,minutes};

  }
  diffLeave = (start, end) => {
    start = start.split(":");
    end = end.split(":");
    let startDate = new Date(0, 0, 0, start[0], start[1], 0);
    let endDate = new Date(0, 0, 0, end[0], end[1], 0);
    let diff = endDate.getTime() - startDate.getTime();
    let hours = Math.floor(diff / 1000 / 60 / 60);
    diff -= hours * 1000 * 60 * 60;
    let minutes = Math.floor(diff / 1000 / 60);

    // If using time pickers with 24 hours format, add the below line get exact hours
    if (hours < 0)
       hours = hours + 24;

    if(hours + (minutes/60) > 8){
      return 8;
    }    
    return hours + (minutes/60);
  }
  diff (id, start, end) { 
    console.log(start)
    console.log(end)
    start = start.split(':');
    end = end.split(':');
    var startDate = new Date(0, 0, 0, start[0], start[1], 0);
    var endDate = new Date(0, 0, 0, end[0], end[1], 0);
    var diff = endDate.getTime() - startDate.getTime();
    var hours = Math.floor(diff / 1000 / 60 / 60);
    diff -= hours * 1000 * 60 * 60;
    var minutes = Math.floor(diff / 1000 / 60);

    // If using time pickers with 24 hours format, add the below line get exact hours

    return (hours <= 9 ? "0" : "") + hours + ":" + (minutes <= 9 ? "0" : "") + minutes;
  }
  styleTime(strTime) {
    return <span style={{ color: '#dddddd' }}>{strTime}</span>;
  }
  totalTime (item){
    var delayTime = {};
    if(item.expectedSignInTime.length !== 0 && item.firstSignIntime.length !== 0)
      delayTime = this.delay(item.expectedSignInTime,item.firstSignIntime);

    var totaltime = '';
    if(item.expectedSignInTime.length === 0){
      totaltime = this.styleTime(this.strNoDate);
    } else if(item.thirdSignIntime === '無資料' && item.secondSignOuttime === '無資料' && typeof item.firstSignOuttime === 'string'){
      totaltime = this.diff(item.eventId, item.expectedSignInTime, item.firstSignOuttime);
    }else if(item.thirdSignIntime === '無資料'&& typeof item.firstSignOuttime === 'string'){
      totaltime = this.wholeTime(
        this.diff(item.eventId, item.expectedSignInTime, item.firstSignOuttime),
        this.diff(item.eventId, item.secondSignIntime, item.expectedSignOutTime)
        );
    }else if(typeof item.thirdSignOuttime === 'string'&& typeof item.firstSignOuttime === 'string'){
      totaltime = this.wholeTime(
        this.diff(item.eventId, item.expectedSignInTime, item.firstSignOuttime),
        this.diff(item.eventId, item.secondSignIntime, item.secondSignOuttime),
        this.diff(item.eventId, item.thirdSignIntime, item.expectedSignOutTime)
        );
    }else{
      totaltime = this.styleTime(this.strNoDate);
    }
    if((delayTime.hours && typeof totaltime === 'string') || (delayTime.minutes && typeof totaltime === 'string'))
    {
      var finalHour = parseInt(totaltime.split(':')[0], 10)  - delayTime.hours;
      var finalMinute = (parseInt(totaltime.split(':')[1], 10) - delayTime.minutes );
      if(finalMinute < 0){
        finalMinute = finalMinute + 60;
        finalHour= finalHour - 1;
      }
      totaltime = `${(finalHour <= 9 ? "0" : "")}${finalHour}:${finalMinute}`
    }
    if(totaltime === 'NaN:NaN')
      totaltime = '無資料';
    return totaltime;
  }
  handleSearchButton() {
    this.props.getPersonalAttendance({
      start: this.state.searchStartDate.format('YYYY-MM-DD'),
      end:  this.state.searchEndDate.format('YYYY-MM-DD'),
      page: this.state.currPage,
      pageSize: this.state.countOfPage,
    });
  }
  handleSaveStaff(dropReason, hasRest) {
    var overtime = this.state.editOvertime;
    // 加班單不處理跨日，開始與結束時間一律固定在申請日期當天
    var range = buildOvertimeRange(overtime);
    if (!range) {
      swal({
        type: 'error',
        title: '加班時間有誤，請重新選擇',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false
      });
      return;
    }

    // 不直接改 state，否則送出失敗時 startAt/endAt 會殘留成字串導致畫面爆掉
    var data = Object.assign({}, overtime, {
      startAt: range.startAt,
      endAt: range.endAt,
      hasRest: hasRest,
      reason: (dropReason === '-1'? '' : dropReason) + (overtime.reason ? ' - '+overtime.reason:''),
      id: this.state.editType === 'ADD' ? -1 : overtime.id,
    });

    axios.post(process.env.REACT_APP_NODE_ENV === 'development'?'https://www.liangshishu.link:46890/api/OverTime':'https://www.liangshishu.link:46888/api/OverTime'
      , data, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'bearer ' + localStorage.getItem('access_token'),
        }
      }).then((response) => {
        console.log(response)
        if (response.data.code === 1) {
          swal({
            type: 'error',
            title: '新增加班單失敗',
            text: response.data.message[0],
            showConfirmButton: false,
            showCloseButton: true,
            heightAuto: false
          }).then(()=>{
            this.toggleEditBlockShow();
          })
          

        }else{
          this.toggleEditBlockShow();
          this.props.getPersonalAttendance({
            start: this.state.searchStartDate.format('YYYY-MM-DD'),
            end:  this.state.searchEndDate.format('YYYY-MM-DD'),
            page: this.state.currPage,
            pageSize: this.state.countOfPage,
          });

        }
  
      });

   
    // API.post('OverTime', data).then((response) => {
    //   console.log(response)
    //   if (response) {
    //       this.toggleEditBlockShow();
    //       this.props.getPersonalAttendance({
    //         start: this.state.searchStartDate.format('YYYY-MM-DD'),
    //         end:  this.state.searchEndDate.format('YYYY-MM-DD'),
    //         page: this.state.currPage,
    //         pageSize: this.state.countOfPage,
    //       });
          

    //   }else{
    //     swal({
    //       type: 'error',
    //       title: '新增加班單失敗',
    //       text: response,
    //       showConfirmButton: false,
    //       showCloseButton: true,
    //       heightAuto: false
    //     }).then(()=>{
    //       this.toggleEditBlockShow();
    //     })
    //   }

    // });
  }
  overTimeStatusByStatus(note,status){
    if(status === '1')
      return '已核准'+note

    if(status === 'S')
      return '審核中'

    if(status === 'R')
    return '退回'

    if(status === 'X')
      return '作廢'
  }
  leaveStatusStrByStatus(eventId ,id, status, hours,leaveTypeName){
    if(status === '1'){
      return leaveTypeName+hours+'小時';
      //return item.overtimeData[0].overtimeHours+'小時';
    }

    if(status === 'S')
      return '審核中'

    if(status === 'R')
      return '已退回'

    if(status === 'X')
      return '已作廢'
  }
  overTimeStatusStrByStatus(eventId ,id, status, hours){
    if(status === '1'){
      return hours+'小時';
      //return item.overtimeData[0].overtimeHours+'小時';
    }
      

    if(status === 'S')
      return ''

    if(status === 'R')
      return <button className="btn btn-md slide-bar-font-color-active" style={{width:'115px'}} onClick={()=>{this.handleOvertimeButton(eventId, id)}}>編輯退回</button>

    if(status === 'X')
      return <button className="btn btn-md delete" style={{width:'115px'}} onClick={()=>{this.handleOvertimeButton(eventId, id)}}>編輯作廢</button>
  }
  overTimeStatus(item){
    var note = item.overtimeData[0].notes ? ':'+item.overtimeData[0].notes:'';
    if(item.overtimeData[0].status === '1')
      return '已核准'+note

    if(item.overtimeData[0].status === 'S')
      return '審核中'

    if(item.overtimeData[0].status === 'R')
    return '退回'

    if(item.overtimeData[0].status === 'X')
      return '作廢'
  }
  overTimeStatusStr(item){
    var note = item.overtimeData[0].notes ? ':'+item.overtimeData[0].notes:'';
    if(item.overtimeData[0].status === '1'){
      return item.overtimeData[0].overtimeHours+'小時';
    }
      

    if(item.overtimeData[0].status === 'S')
      return ''

    if(item.overtimeData[0].status === 'R')
    return <button className="btn btn-md slide-bar-font-color-active" style={{width:'115px'}} onClick={()=>{this.handleOvertimeButton(item.id, -1)}}>編輯退回</button>

    if(item.overtimeData[0].status === 'X')
      return <button className="btn btn-md delete" style={{width:'115px'}} onClick={()=>{this.handleOvertimeButton(item.id, -1)}}>編輯作廢</button>
  }

  handleOnChangeInput(key, e) {
    let newObj = Object.assign({}, this.state.editOvertime);
    if(moment.isMoment(e)){
      newObj[key] = e;
    }else if(key=='hasRest'){
      console.log(e.target.value)
      if(e.target.value == 1)
        newObj[key] = true;
      else
        newObj[key] = false;
    }else{
      newObj[key] = e.target.value;
    }
    this.setState({
      editOvertime: newObj
    });
  }
  cutTimeFunc(date) {
    if (date) return date.split('T')[0] + ' ' + date.split('T')[1].substring(0, 8);
    return date;
  }
  onChangeStep = (step) => {
    if (this.state.step === step) return;
    this.setState({
      step: step,
    });
  };
  render() {
    let { count, records, totalSalaryHour, totalActualHour,pounchCount,totalOverTimeHour, deservedHour, totalAlreadyHour, totalLeaveHour } = this.props.PersonsSignInTimeState;
    let totalPage = Math.ceil(count / this.state.countOfPage);
    let newRecords = [];
    const settings = {
      dots: true,
      arrows: false,
      responsive: [
        { settings: { slickGoTo: 0, initialSlide: 0 } }
      ]
    };
    records.slice((this.state.currPage - 1) * this.state.countOfPage, ((this.state.currPage - 1) * this.state.countOfPage) + this.state.countOfPage).forEach((item) => {
      let newItem = {
        id: item.id,
        name: item.name,
        jobType: item.jobType,
        eventId: item.eventId,
        leaveData: item.leaveData,
        expectedDate: item.expectedDate,
        expectedSignInTime: item.expectedSignInTime === '00:00'? '無資料':item.expectedSignInTime,
        expectedSignOutTime: item.expectedSignOutTime=== '23:59'? '無資料':item.expectedSignOutTime,
        firstSignId: item.data[0] ? item.data[0].id : '無資料',
        firstSignIntime: item.data[0] ? item.data[0].actualSignInTime : '無資料',
        firstSignOuttime: item.data[0] ? item.data[0].actualSignOutTime : '無資料',

        secondSignId: item.data[1] ? item.data[1].id : '無資料',
        secondSignIntime: item.data[1] ? item.data[1].actualSignInTime : '無資料',
        secondSignOuttime: item.data[1] ? item.data[1].actualSignOutTime : '無資料',

        thirdSignId: item.data[2] ? item.data[2].id : '無資料',
        thirdSignIntime: item.data[2] ? item.data[2].actualSignInTime : '無資料',
        thirdSignOuttime: item.data[2] ? item.data[2].actualSignOutTime : '無資料',
        totalWorkTime: item.totalWorkTime ? this.calculateTotalWorkTime(item.totalWorkTime.toFixed(1)) : '無資料',
        totalSalaryTime: item.totalSalaryTime ? this.calculateTotalWorkTime(item.totalSalaryTime.toFixed(1)) : '無資料',
        overtimeData: item.overTimeData,
        createdUser: item.createdUser
      }
      newRecords.push(newItem);
    });
    
    const slides = newRecords.map((item, index) => (
      <div key={index}>
      <table className="u-table u-table-border u-table-striped u-table-media-phone">
        <tbody style={item.rowStyle}>
          <tr>
            <th>上班日</th>
            <td>{item.expectedDate}</td>
          </tr>
          <tr>
            <th>預期簽到</th>
            <td>{item.expectedSignInTime}</td>
          </tr>
          <tr>
            <th>預期簽退</th>
            <td>{item.expectedSignOutTime}</td>
          </tr>
          <tr>
            <th>簽到一</th>
            <td>{item.firstSignIntime}</td>
          </tr>
          <tr>
            <th>簽退一</th>
            <td>{item.firstSignOuttime}</td>
          </tr>
          <tr>
            <th>簽到二</th>
            <td>{item.secondSignIntime}</td>
          </tr>
          <tr>
            <th>簽退二</th>
            <td>{item.secondSignOuttime}</td>
          </tr>
          <tr>
            <th>簽到三</th>
            <td>{item.thirdSignIntime}</td>
          </tr>
          <tr>
            <th>簽退三</th>
            <td>{item.thirdSignOuttime}</td>
          </tr>
          {/* <tr>
            <th>總工時</th>
            <td>{item.totalWorkTime}</td>
          </tr> */}
          <tr>
            <th>算薪工時</th>
            <td>{item.totalSalaryTime}</td>
          </tr>
          <tr>
            <th>加班時段</th>
            <td>{item.overtimeData.length > 0 ?
                      item.overtimeData.map((overdata,index)=>{
                        return (<React.Fragment key={index}><span>{moment(overdata.startAt).format('HH:mm')}~{moment(overdata.endAt).format('HH:mm')}</span><br/></React.Fragment>)
                      })
                  :''}</td>
          </tr>
          <tr>
            <th>狀態</th>
            <td>{
              item.overtimeData.length > 0 ?
              item.overtimeData.map((overdata,index)=>{
                return (<React.Fragment key={index}><span>{this.overTimeStatusByStatus( overdata.notes, overdata.status)}</span><br/></React.Fragment>)
              })
              :''
            }</td>
          </tr>
          <tr>
            <th>核准</th>
            <td>{item.overtimeData.length > 0?
            item.overtimeData.map((overdata,index)=>{
              return (<React.Fragment key={index}><span>{overdata.status == '1' && overdata.payType == 1?'補休':overdata.status == '1' && overdata.payType == 5?'加班費+補休':overdata.status == '1'?'加班費':'未核准'}</span><br/></React.Fragment>)
            })
            :''}</td>
          </tr>
          <tr>
            <th>加班單</th>
            <td>{


                item.firstSignOuttime!=='無資料' && item.firstSignOuttime != null ?  
                item.overtimeData.length > 0 ?
                item.overtimeData.map((overdata,index)=>{
                  return (<React.Fragment key={index}><span>{this.overTimeStatusStrByStatus(item.id, overdata.id, overdata.status, overdata.overtimeHours)}</span><br/></React.Fragment>)
                })
                :
                <button className="btn btn-md success m-l-8" style={{width:'115px'}} onClick={()=>{this.handleOvertimeButton(item.id, -1)}}>新增</button>
                :''
              }</td>
          </tr>
          <tr>
            <th>請假單</th>
            <td>
            {
                           
                           item.leaveData.length > 0 ?
                           item.leaveData.map(overdata=>{
                             return (<React.Fragment key={index}><span>{this.leaveStatusStrByStatus( item.id, overdata.id, overdata.status, overdata.leaveHours, overdata.leaveTypeName)}</span><br/></React.Fragment>)
                           })
                           :
                           ''
                           
                         }
              </td>
          </tr>
        </tbody>
      </table>
    </div>
    ))
    return (
    <div className="p-signTime">
      <div className='u-block'>
        <div className="u-title">個人上班記錄
        </div>
        <div className="sign-notice">
        <div className="u-notice">日期為<span style={{color:'orange'}}>橘色</span>表示該筆排班是由填假單新增，非排班新增。</div>
        <div className="u-notice">當月應上工時 = (總天數 - 六日天數 - 國定假日) * 8</div>
        <div className="u-notice">當月已上工時 = 算薪工時＞8以8計，未足8則照算薪工時</div>
        <div className="u-notice">當月請假工時 = 加總特休和補休</div>
        <div className="u-notice">算薪工時工時 = 上班時數加特休或補休</div>
          <div className="u-notice">*公司規定之休息時間:</div>
          <div className="u-notice">(1) 填班4小時以下不休息</div>
          <div className="u-notice">(2) 填班4小時＜工時＜8小時，則休息半小時</div>
          <div className="u-notice">(3) 填班8小時＜＝工時＜12小時，則休息一小時</div>
          <div className="u-notice">(4) 填班12小時＜＝工時，則休息二小時</div>
          <div className="u-notice">*溫馨提醒: </div>
          <div className="u-notice">若無預期排班資料將導致工時計算出現誤差，請待主管排班後取得最終工時計算。</div>
        </div>
        <div className="u-search-box">
        <span>簽到天數:{pounchCount}天</span>
        {/* <span>參考總工時:{totalActualHour}小時</span> */}
        <span>當月應上工時:{deservedHour}小時</span>
        {/* <span>算薪總工時:{totalSalaryHour}小時</span> */}
        <span>當月已上工時:{totalAlreadyHour}小時</span>
        <span>當月請假工時:{totalLeaveHour}小時</span>
        {/* <span>核准加班時數:{totalOverTimeHour}小時</span> */}
          <div className="date-input">
            <span style={{flex: '0 0 54px'}}>時間：</span>
            <DatePicker
              id="date_picker_searchStartDate"
              locale="zh-tw"
              dateFormat="YYYY-MM-DD"
              selected={this.state.searchStartDate}
              onChange={this.handleSearchStartDateChange}
              className="u-form__input mobile-hide"
              disabledKeyboardNavigation
            />
            <button
                className="btn datepickinput desktop--hide"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('date_picker_searchStartDate').click();
                }}
            >
              {this.state.searchStartDate.format('l')}
            </button>
            
          </div>
          <div className="date-input">
            <span style={{flex: '0 0 54px'}}>到：</span>
            <DatePicker
              id="date_picker_searchEndDate"
              locale="zh-tw"
              dateFormat="YYYY-MM-DD"
              selected={this.state.searchEndDate}
              onChange={this.handleSearchEndDateChange}
              className="u-form__input mobile-hide"
              disabledKeyboardNavigation
            />
            <button
                className="btn datepickinput desktop--hide"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('date_picker_searchEndDate').click();
                }}
            >
              {this.state.searchEndDate.format('l')}
            </button>
          </div>
          <button className="btn btn-md save m-l-8" onClick={this.handleSearchButton}>查詢</button>
          <button
                type="button"
                className="btn success btn-md"
                onClick={() => {
                    this.handleToggleOpenFillLeaveBlock(moment().format('YYYY-MM-DD'), -1, 'ADD')
                }}
                >
                    <span>請假</span>
            </button>
        </div>
        <div className="u-table-responsive">
        <table className="u-table u-table-border u-table-striped u-table-media">
            <thead>
              <tr>
                <th>預計簽到日</th>
                <th>預期簽到退時間</th>
                <th>第一段簽到退</th>
                <th>第二段簽到退</th>
                <th>第三段簽到退</th>
                {/* <th>總工時</th> */}
                {/* <th data-bs-toggle="tooltip" data-bs-placement="top" title="實際打卡時間(一段班會套用休息規則)">總工時</th> */}
                <th data-bs-toggle="tooltip" data-bs-placement="top" title="總工時修正5分鐘取整至小數點0或0.5，超過8小時取8，若有加班會加上加班時間">算薪工時</th>
                <th>加班時段</th>
                <th>狀態</th>
                <th>核准</th>
                <th>加班單</th>
                <th>請假單</th>
              </tr>
            </thead>
            <tbody>
              {
                newRecords.map((item, index) => {

                  var leaveCreate = item.createdUser == undefined && item.leaveData.length > 0;

                  return (
                    <tr key={index}>
                      <td style={{color:leaveCreate?'orange':''}}>{item.expectedDate}</td>
                      <td>{item.expectedSignInTime}~{item.expectedSignOutTime}</td>
                      <td>{item.firstSignIntime}~{item.firstSignOuttime}</td>
                      <td>{item.secondSignIntime}~{item.secondSignOuttime}</td>
                      <td>{item.thirdSignIntime}~{item.thirdSignOuttime}</td>
                      {/* <td>{this.totalTime(item)}</td> */}
                      {/* <td>{Math.floor(item.totalWorkTime) + (item.totalWorkTime % 1 >= 0.5 ? 0.5 : 0)}</td> */}
                      <td>{item.totalSalaryTime}</td>
                      <td>{item.overtimeData.length > 0 ?
                      item.overtimeData.map((overdata,indexx)=>{
                        return (<React.Fragment key={indexx}><span>{moment(overdata.startAt).format('HH:mm')}~{moment(overdata.endAt).format('HH:mm')}</span><br/></React.Fragment>)
                      })
                      
                      :''}</td>
                      <td>
                        {
                          item.overtimeData.length > 0 ?
                          item.overtimeData.map((overdata,indexx)=>{
                            return (<React.Fragment key={indexx}><span>{this.overTimeStatusByStatus( overdata.notes, overdata.status)}</span><br/></React.Fragment>)
                          })
                          :''
                        }
                      </td>
                      <td>{item.overtimeData.length > 0?
                      item.overtimeData.map((overdata,indexx)=>{
                        return (<React.Fragment key={indexx}><span>{overdata.status == '1' && overdata.payType == 1?'補休':overdata.status == '1' && overdata.payType == 5?'加班費+補休':overdata.status == '1'?'加班費':'未核准'}</span><br/></React.Fragment>)
                      })
                      :''}</td>
                      <td>
                        {
                          // item.firstSignOuttime!=='無資料' && item.firstSignOuttime != null ?
                          // item.overtimeData.length > 0 ?
                          // item.overtimeData[0].status === 'R'?
                          // item.overtimeData[0].status === 'X'?
                          // <button className="btn btn-md delete" style={{width:'115px'}} onClick={()=>{this.handleOvertimeButton(item.id)}}>編輯作廢</button>

                          // :
                          // <button className="btn btn-md slide-bar-font-color-active m-l-8" style={{width:'115px'}} onClick={()=>{this.handleOvertimeButton(item.id)}}>編輯退回</button>
                          // :
                          // <span>{this.overTimeStatusStr(item.overtimeData[0].status) + (item.overtimeData[0].notes?':' + item.overtimeData[0].notes:'')}</span>
                          // :
                          // <button className="btn btn-md success m-l-8" style={{width:'115px'}} onClick={()=>{this.handleOvertimeButton(item.id)}}>新增</button>
                          // :''


                          item.firstSignOuttime!=='無資料' && item.firstSignOuttime != null ?  
                          item.overtimeData.length > 0 ?
                          item.overtimeData.map((overdata,indexx)=>{
                            return (<React.Fragment key={indexx}><span>{this.overTimeStatusStrByStatus( item.id, overdata.id, overdata.status, overdata.overtimeHours)}</span><br/></React.Fragment>)
                          })
                          :
                          <button className="btn btn-md success m-l-8" style={{width:'115px'}} onClick={()=>{this.handleOvertimeButton(item.id, -1)}}>新增</button>
                          :''
                        }
                        
                      </td>
                      <td>
                        {
                           
                          item.leaveData.length > 0 ?
                          item.leaveData.map((overdata,indexx)=>{
                            return (<React.Fragment key={indexx}><span>{this.leaveStatusStrByStatus( item.id, overdata.id, overdata.status, overdata.leaveHours, overdata.leaveTypeName)}</span><br/></React.Fragment>)
                          })
                          :
                          ''
                          
                        }
                        
                      </td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </div>
        {
          newRecords.length > 0 ? <Slider {...settings}>
          {
            slides
          }
        </Slider>:''
        }

        <div className="u-notice">※無資料和店長確認。</div>
        <div className="pagination-box">
          <Pagination 
            currPage={this.state.currPage} totalPage={totalPage}
            onChangPage={this.handleChangePage}
          />
        </div>

        <EditOvertime
            editType={this.state.editType}
            isShow={this.state.isEditShow}
            editInformation={this.state.editOvertime}
            onChangeFunc={this.handleOnChangeInput}
            saveFunc={this.handleSaveStaff}
            toggleFunc={this.toggleEditBlockShow}
          />

      <FillLeave 
          isVisible={this.state.isFillLeaveOpen} 
          toggleOpen={this.handleToggleOpenFillLeaveBlock} 
          targetDate = {this.state.editFillLeaveDate} 
          allStaff={this.state.employees} 
          editTarget={this.state.editFillLeaveTarget}
          allLeaveType={this.state.leaveTypeList} 
          saveWorkRecordFunc={this.handleFillLeave}
          targetEventId={this.state.editFillLeaveId}
          onChangeFunc={this.handleOnChangeFillLeaveInput}
          longLeave={this.state.longLeave}
          remainHours = {this.state.remainHours- this.state.signingAnnualHours}
          compensatoryHours = {this.state.compensatoryHours- this.state.signingCompensatoryHours}
        />
      </div>
      
    </div>
    )
  }
}

const mapStateToProps = (store) => ({
  SendAPIState: store.SendAPIStatusState,
  PersonsSignInTimeState: store.PersonsSignInTimeState,
})

export default connect(mapStateToProps,{
  getPersonalAttendance,
  InitAPIStatus
})(PersonalSignInOutTime)